/**
 * Total Golden Chips Balance Replacer Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var user = require('user');
    var BaseModel = require('common/base.model');
    var server = require('server');

    module.exports = BaseModel.extend({
        defaults: function() {
            return {
                amount: 0,
                currencyCode: user.get('currencyCode')
            };
        },

        sync: function(method, model, options) {
            if (method === 'read') {
                return this.getGoldenChipsBalances(options);
            }
        },

        parse: function(response) {
            var goldenChipsBalances = response.data.goldenChipsBalances || [];

            return goldenChipsBalances.length
                ? _
                    .chain(goldenChipsBalances)
                    .map(this.multiplyCountWithAmount)
                    .reduce(this.sumMultiplications, {})
                    .value()
                : this.toJSON();
        },

        multiplyCountWithAmount: function(balance) {
            return _.extend({}, balance.goldenChipValue, {
                amount: balance.goldenChipsCount * balance.goldenChipValue.amount
            });
        },

        sumMultiplications: function(totalBalance, balance) {
            return _.extend({}, balance, {
                amount: (totalBalance.amount || 0) + balance.amount
            });
        },

        getGoldenChipsBalances: function(options) {
            var request = {
                ID: 32023,
                responses: [32024, 32025],
                description: 'Get Golden Chips Balances Request'
            };

            return server.send(request)
                .done(options.success)
                .fail(options.error);
        }
    });
});
